export enum TicketAction {
  ABSENCE = 'ABSENCE',
  CONFIRMATION = 'CONFIRMATION',
  RESTORATION = 'RESTORATION',
  USING = 'USING',
}
